import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-finanzen-header',
  templateUrl: './finanzen-header.html',
  styleUrl: './finanzen-header.scss',
  standalone: true,
  imports: [],
})
export class FinanzenHeader {
  @Output() closeClicked = new EventEmitter<void>();
}
